import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/lib/api';

const SETTINGS_KEY = ['settings'] as const;

export function useSettings() {
  return useQuery<Record<string, string>>({
    queryKey: SETTINGS_KEY,
    queryFn: async () => {
      const { data } = await api.get<Record<string, string>>('/settings');
      return data;
    },
  });
}


/**
 * Notion de marge activée pour l'organisation (réglage `marginsEnabled`,
 * Réglages → Général). Quand désactivée, les marges ne sont plus affichées ni
 * éditables (fiche transporteur, devis) ; les marges enregistrées restent
 * appliquées au calcul du prix de vente. Défaut : activée.
 */
export function useMarginsEnabled(): boolean {
  const { data: settings } = useSettings();
  return settings?.marginsEnabled !== 'false';
}

export function useUpdateSetting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ key, value }: { key: string; value: string }) => {
      const { data } = await api.put(`/settings/${key}`, { value });
      return data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: SETTINGS_KEY });
    },
  });
}
